import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const CancelledOrders = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row">
              <div className="accordion" id="accordionPanelsStayOpenExample">
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingNine2"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseNine2"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseNine2"
                    >
                      <div className="col d-flex align-items-center justify-content-between">
                        <h4 className="event-alert p-0 mb-0">
                          Rejected Orders
                        </h4>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseNine2"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingNine2"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>ID</th>
                                    <th>Payee</th>
                                    <th className="text-right">Total Cost</th>
                                    <th className="text-right">Discount</th>
                                    <th className="text-right">
                                      Item Discount
                                    </th>
                                    <th className="text-right">Sales Tax</th>
                                    <th className="text-right">Final Cost</th>
                                    <th>Rejection Date</th>
                                    <th className="action-td">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr className="order_row">
                                    <td>OR000002</td>
                                    <td className="payeeTd">
                                      <b>Marketing Payee</b>
                                      <br />
                                      ID INv2
                                    </td>
                                    <td className="align-right">$2,500.00</td>
                                    <td className="align-right">($0.00)</td>
                                    <td className="align-right">($0.00)</td>
                                    <td className="align-right">$125.00</td>
                                    <td className="align-right">$2,625.00</td>
                                    <td>Oct 02,2021</td>
                                    <td className="action-td">
                                      <a href="#_" class="circle_icon">
                                        <i class="iconSprites eye-icon"></i>
                                      </a>
                                    </td>
                                  </tr>
                                  <tr className="order_row">
                                    <td>OR000002</td>
                                    <td className="payeeTd">
                                      <b>Marketing Payee</b>
                                      <br />
                                      ID INv2
                                    </td>
                                    <td className="align-right">$2,500.00</td>
                                    <td className="align-right">($0.00)</td>
                                    <td className="align-right">($0.00)</td>
                                    <td className="align-right">$125.00</td>
                                    <td className="align-right">$2,625.00</td>
                                    <td>Oct 02,2021</td>
                                    <td className="action-td">
                                      <a href="#_" class="circle_icon">
                                        <i class="iconSprites eye-icon"></i>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default CancelledOrders;
